var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$temAcessoView('CTRLACS-APP-01'))?_c('div',{staticClass:"float-right"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.$router.push({ name: 'Aplicacoes_Inserir' })}}},[_c('span',[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" Inserir Aplicação")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }